module.exports = __webpack_public_path__ + "img/Cas9variants_N.b4f6eda1.svg";